import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useBlockAndReportCharacterMutation } from '~/features/character';
import { SendBlockAndReportCharacterRequest } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import useToast from '~/store/useToast';

const useBlockAndReport = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [blockCharacter, setBlockCharacter] = useState('');

  const { mutate: characterMutate, isPending: isCharacterPending } =
    useBlockAndReportCharacterMutation();

  const handleSendBlockAndReport = async (id: string, onClose: () => void) => {
    if (!id) return;

    const requestData: SendBlockAndReportCharacterRequest = {
      character_id: id,
      report_message: blockCharacter,
    };
    characterMutate(requestData, {
      onSuccess: () => {
        setBlockCharacter('');
        showToast('success', 'Success to send report and block.');
        onClose();
        queryClient.invalidateQueries();
        navigate(PAGE_ROUTE.MAIN, { replace: true });
      },
    });
  };

  return {
    blockCharacter,
    setBlockCharacter,
    handleSendBlockAndReport,
    isReportPending: isCharacterPending,
  };
};

export default useBlockAndReport;
